import { UserAvatar } from '@v2/components/display/UserAvatar/UserAvatar';
import { Button } from '@v2/components/ui/button';
import { Textarea } from '@webV2/components/ui/textarea';
import { AddCommentProps } from './types';

export const AddComment = ({
  newComment,
  onCommentChange,
  onSubmit,
  isLoading,
  authenticatedUser
}: AddCommentProps) => {
  return (
    <div className="flex space-x-3">
      <UserAvatar
        user={{
          name: authenticatedUser.user?.name || '',
          email: authenticatedUser.user?.email || '',
          profile_photo_url: authenticatedUser.user?.profile_photo_url || ''
        }}
        size="sm"
        className="flex-shrink-0"
      />
      <div className="flex-1">
        <Textarea
          placeholder="Add a comment"
          value={newComment}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
            onCommentChange(e.target.value)
          }
          className="min-h-[80px] resize-none border-gray-200 placeholder:text-gray-400 focus:border-gray-300 focus:ring-0"
          onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
              onSubmit();
            }
          }}
        />
        {newComment.trim() && (
          <div className="mt-3">
            <Button
              onClick={onSubmit}
              size="sm"
              className="bg-gray-900 text-white hover:bg-gray-800"
              disabled={isLoading}
            >
              {isLoading ? 'Adding...' : 'Comment'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
